// extracted by mini-css-extract-plugin
module.exports =  {"customSkeleton":"customSkeleton_n0iWienu","animated":"animated_wSLtwXkU","skeleton-wave":"skeleton-wave_pfAcSXWT"};